import { useEffect, useState } from 'react';
import imWebSocketClient from '@formosa/shared/api/imWebSocketClient';
import { useAuth } from '../../auth/AuthContext';

export default function useTravelImSession() {
  const { isAuthenticated } = useAuth();
  const [socketStatus, setSocketStatus] = useState(() => imWebSocketClient.getStatus?.() || 'idle');

  useEffect(() => {
    if (!isAuthenticated) {
      imWebSocketClient.disable();
      setSocketStatus('idle');
      return undefined;
    }
    imWebSocketClient.reconnectWithToken();
    const offStatus = imWebSocketClient.onStatus((status) => setSocketStatus(status));
    return () => {
      if (typeof offStatus === 'function') offStatus();
      imWebSocketClient.disable();
    };
  }, [isAuthenticated]);

  return socketStatus;
}
